import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import LoadScript from 'vue-plugin-load-script'
import VueYoutube from 'vue-youtube'
import VueMeta from 'vue-meta'
import VueGtag from "vue-gtag";

// import { VueReCaptcha } from 'vue-recaptcha-v3'
import * as zenScroll from 'zenscroll';

window.zenScroll = zenScroll

// Global style
import './styles/main.scss'

Vue.config.productionTip = false

Vue.component('header-menu', Header)
Vue.component('footer-menu', Footer)

Vue.use(LoadScript)
Vue.use(VueYoutube)
Vue.use(VueMeta)
Vue.use(VueGtag, {
  config: { id: 'G-BQ7K3H4HNM' },
  appName: 'Arcaea Web',
  pageTrackerScreenviewEnabled: true
}, router);

// Vue.use(VueReCaptcha, { siteKey: '6Lf_MAoaAAAAADD4eS_GrQl-xOiSq_lY7less-ii' })

Vue.mixin({
  data(): any {
    return {
      worldUnlocks: ['chap1', 'chap2', 'chap3', 'chap4', 'chap5', 'chap6', 'chap7', 'beyond'],
    }
  },
  methods: {
    formatDateTime(timestamp: number): string {
      const date = new Date(timestamp)
      return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], {hour: "2-digit", minute: "2-digit"})}`;
    },
    formatUserCode(userCode: string): string {
      return userCode.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    formatScore(score: number, showZeroes = false): string {
      if (score <= 0 && !showZeroes) {
        return '-';
      }
      return score.toString().padStart(8, '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    calculateGrade(score: number) {
      let grade = 'D'
      if (score >= 9900000) {
        grade = 'EX+'
      } else if (score >= 9800000) {
        grade = 'EX'
      } else if (score >= 9500000) {
        grade = 'AA'
      } else if (score >= 9200000) {
        grade = 'A'
      } else if (score >= 8900000) {
        grade = 'B'
      } else if (score >= 8600000) {
        grade = 'C'
      }
      return grade;
    },
    calculateClearType(clearType: number) {
      // NONE: -1,
      // FAIL: 0,
      // NORMAL: 1,
      // FULLCOMBO: 2,
      // PERFECT: 3,
      // CLEAR_EASY: 4,
      // CLEAR_HARD: 5,
      const clearTypes = ['L', 'C', 'F', 'P', 'C', 'C'];
      if (clearType < 0) {
        return '-'
      }
      return clearTypes[clearType];
    },
    getClearTypeDiamondAssets(clearType: number) {
      const clearTypes = [
        'L-Clear.svg',
        'C-Clear.svg',
        'F-Clear.svg',
        'P-Clear.svg',
        'C-Clear-Easy.svg',
        'C-Clear-Hard.svg',
      ];
      if (clearType < 0) {
        return clearTypes[0];
      }
      return clearTypes[clearType];
    },
    formatDifficulty(difficulty: number) {
      const difficultyText = ['PST', 'PRS', 'FTR', 'BYD'];
      return difficultyText[difficulty];
    },
    getRatingDiamondAsset(rating) {
      if (rating < 0) {
        return 'rating_off'
      } else if (rating <= 349) {
        return 'rating_0';
      } else if (rating <= 699) {
        return 'rating_1'
      } else if (rating <= 999) {
        return 'rating_2'
      } else if (rating <= 1099) {
        return 'rating_3'
      } else if (rating <= 1199) {
        return 'rating_4'
      } else if (rating <= 1249) {
        return 'rating_5'
      } else if (rating <= 1299) {
        return 'rating_6'
      } else if (rating <= 9999) {
        return 'rating_7'
      }
      return 'rating_0'
    },
    getcharacterDiamondAssetName(characterId: number, stats: any) {
      const isUncapped = characterId === 5 ? false : stats.is_uncapped && !stats.is_uncapped_override;
      return `${characterId}${isUncapped ? 'u' : ''}`;
    },
    getCharacterAssetName(character: any): string {
      return `${character.name}${character.is_uncapped && !character.is_uncapped_override ? '_awaken' : ''}`
    },
    calculateExpPercentage(level: number, currentExp: number) {
      const levelExps = [
        0,
        50,
        100,
        150,
        200,
        300,
        450,
        650,
        900,
        1200,
        1600,
        2100,
        2700,
        3400,
        4200,
        5100,
        6100,
        7200,
        8500,
        10000,
        11500,
        13000,
        14500,
        16000,
        17500,
        19000,
        20500,
        22000,
        23500,
        25000
      ];
      const levelExp = levelExps[level - 1];

      return (currentExp === levelExp) ? 100 : Math.floor((currentExp - levelExp) * 100 / (levelExps[Math.min(level, levelExps.length)] - levelExp));
    },
    getCharacterDiamondImageAsset(characterDiamondAssetName: string): NodeRequire {
      try {
        return require(`@/assets/diamonds/${characterDiamondAssetName}_icon.png`);
      } catch (e) {
        return require(`@/assets/diamonds/unknown_icon.png`);
      }
    },
    getcharacterAsset(characterAssetName: string): NodeRequire {
      try {
        return require(`@/assets/characters/${characterAssetName}.png`);
      } catch (e) {
        return require(`@/assets/characters/unknown.png`);
      }
    },
    calculateRatingDecimal(rating: number): string {
      const decimal = rating % 100;
      return decimal < 10 ? `0${decimal}` : `${decimal}`;
    },
    getServerLocaleName() {
      return this.$i18n.locale === 'zh' ? 'zh-Hans' : 
        this.$i18n.locale === 'zh-hant' ? 'zh-Hant' : this.$i18n.locale;
    },
    getCharacterLocaleName(displayName) {
      const locale = (this as any).getServerLocaleName();

      return displayName[locale] ? displayName[locale] : '';
    },
    getCharacterLocaleVariant(variant) {
      if (variant) {
        const locale = (this as any).getServerLocaleName();
        return variant[locale] && Boolean(variant[locale].trim()) ? variant[locale] : '';
      }
      return '';
    },
    getCharacterLocaleSkillText(skillText) {
      const locale = (this as any).getServerLocaleName();

      return skillText[locale] ? skillText[locale] : '';
    }
  },
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    // For song contest
    // this.$router.push('/')
    const html = document.documentElement
    html.setAttribute('lang', i18n.locale)
  }
}).$mount('#app')